import { render } from "./organization.vue?vue&type=template&id=34214d7b&scoped=true&ts=true"
import script from "./organization.vue?vue&type=script&lang=ts"
export * from "./organization.vue?vue&type=script&lang=ts"

import "./organization.vue?vue&type=style&index=0&id=34214d7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34214d7b"]])

export default __exports__